// React
import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Components
import BCartPicker from 'ui/blocks/Picker/types/cart'
import { TimeslotsPicker } from './Picker'

// Shared
import useWindowSize from 'shared/utils/useWindowSize'

export const TimeslotsDesktop = (props) => {
  const portalRef = useRef(null)

  const { width } = useWindowSize()

  // 866px is the breakpoint when the modal is starting to shrink
  const numberOfMonths = (width > 866 && props.inline) ? 2 : 1

  return (
    <TimeslotsPicker
      {...props}
      numberOfMonths={numberOfMonths}
      portalRef={portalRef}
      usePortal={props.inline}
    >
      <BCartPicker.Portal ref={portalRef} />
    </TimeslotsPicker>
  )
}

TimeslotsDesktop.propTypes = {
  disabled: PropTypes.bool,
  inline: PropTypes.bool
}
